// extracted by mini-css-extract-plugin
export default {"noActionsMessage":"QuinipolosToAnswer_noActionsMessage__Lo07j","pagination":"QuinipolosToAnswer_pagination__DLESe"};